import { _ } from "~/i18n";
import { createPremiumIcon, node } from "~/util/dom";

export function createPremiumPromo() {
	const button = node("button", { type: "button", className: "premiumPromo" });
	const text = node("p");

	text.append(node("span", {}, _("profile.premiumPromo.text1")), node("strong", {}, _("profile.premiumPromo.text2")));
	button.append(createPremiumIcon(), text);

	return button;
}
